var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_wrapper pop-up",class:_vm.showPopup},[_c('div',{staticClass:"main_block"}),_c('div',{staticClass:"main_color"},[_vm._v(" "+_vm._s(_vm.showPopup)+"! ")])])}
var staticRenderFns = []

export { render, staticRenderFns }